import { render, staticRenderFns } from "./Tabs.vue?vue&type=template&id=04b543b2&scoped=true&"
import script from "./Tabs.vue?vue&type=script&lang=ts&"
export * from "./Tabs.vue?vue&type=script&lang=ts&"
import style0 from "./Tabs.vue?vue&type=style&index=0&id=04b543b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b543b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04b543b2')) {
      api.createRecord('04b543b2', component.options)
    } else {
      api.reload('04b543b2', component.options)
    }
    module.hot.accept("./Tabs.vue?vue&type=template&id=04b543b2&scoped=true&", function () {
      api.rerender('04b543b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Card/Live/Tabs.vue"
export default component.exports